import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useCurrentUser, QBox, QCenter, QNotFound, QSpinner } from '@qualio/ui-components';
import { useTaskDetails } from '../../../hooks';

const TaskDetailsProxy: React.FC = () => {
  const navigate = useNavigate();
  const { companyId } = useCurrentUser();
  const { taskId } = useParams();
  const { task, isTaskError } = useTaskDetails(companyId, Number(taskId));

  useEffect(() => {
    if (task) {
      navigate(`/events/${task.related_issue_id}?task_id=${task.id}`);
    }
  }, [task, navigate]);

  // The task couldn't be fetched (e.g. a 404 for a deleted / non-existent task, or another fetch
  // failure after retries). Show the not-found page instead of spinning forever.
  if (isTaskError && !task) {
    return <QNotFound data-cy="task-not-found" />;
  }

  return (
    <QBox minHeight="270px">
      <QCenter pt={10}>
        <QSpinner />
      </QCenter>
    </QBox>
  );
};

export default TaskDetailsProxy;
